import * as React from 'react';
import {useEffect} from 'react';
import {styled} from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Stack from '@mui/material/Stack';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import LocalHospitalOutlinedIcon from '@mui/icons-material/LocalHospitalOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import center from '../../assets/main/center.png';
import {useNavigate} from "react-router-dom";
import * as util from "../../utils/util";
import api from "../../utils/api";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import main_bg from '../../assets/images/main_bg.png'
import {relative} from 'path';
import arrowimg from '../../assets/images/main_arrow.png'
import tab04 from "../../assets/images/tab_01.png"
import EventBusyIcon from '@mui/icons-material/EventBusy';
import Chip from "@mui/material/Chip";
import { Divider } from '@mui/material';

const Img = styled('img')({
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
});

const TopMan = styled('img')({
    marginLeft: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
});

const topMan = {
    position: 'relative',
    top: '74px',
    right: '14px'
}

const topContainer = {
    height: 295,
    backgroundImage: `url(${"../../src/assets/main/mainTop.png"})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
};

interface Window {
    ReactNativeWebView: {
        postMessage: (message: string) => void;
    };
}

const MainMedical = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = React.useState(false);
    const [reservationList, setReservationList] = React.useState([{
        famGrade: '', firstWishDate: '', ipDate: '', hoName: '',
        famName: '', rsvName: '', hoImage: '', rsvId: '', reservationStatus: { code: -999, name: '' }
    }]);
    const [counselList, setCounselList] = React.useState([]);
    const [allListCnt, setAllListCnt] = React.useState(0);

    useEffect(() => {

        setLoading(true);
        // 예약 목록
        if (util.strNull(window.localStorage.userCusID) !== '') {
            api.post('customer/api/v1/CU_004_001', { cusId: window.localStorage.userCusID }).then((res: any) => {
                const nowYear = new Date().getFullYear().toString();

                // 건강검진
                setReservationList(res.data.inspection.filter((v: any) => v.reservationStatus.code >= 0
                    && util.strNull(v.ipDate) !== '' ? v.ipDate.startsWith(nowYear) : v.firstWishDate.startsWith(nowYear))); // 해당연도 && 예약대기, 예약확정, 수진완료, 결과등록 데이터만 출력

                // 심리상담
                const filteredData = res.data.counsel.filter((v: any) => v.reservationStatus.code >= 0
                && util.strNull(v.ipDate) !== '' ? v.ipDate.startsWith(nowYear) : v.firstWishDate.startsWith(nowYear));
                const maxCount = Math.max(...filteredData.map((v: any) => v.count));
                setCounselList(filteredData.filter((v: any) => v.count === maxCount));

                // 총 갯수
                setAllListCnt(res.data.inspection.concat(res.data.counsel).filter((v: any) => v.reservationStatus.code >= 0
                && util.strNull(v.ipDate) !== '' ? v.ipDate.startsWith(nowYear) : v.firstWishDate.startsWith(nowYear)).length);

                setLoading(false);
            }).catch(function (error: any) {
                console.log(error)
            });
        } else {
            setTimeout(() => {
                setLoading(false);
            }, 500);
        }
    }, []);


    function logout() {
        window.localStorage.clear();
        alert('로그아웃 되었습니다.');
        navigate('/login');
    }


    return (
        <React.Fragment>
            <img src={main_bg} alt="" style={{ width: '100%', position: 'absolute', zIndex: 0, left: 0, height: '400px' }} />
            <Grid container className=" justifycontent_spacebetween" sx={{ position: 'relative', zIndex: 3, mt: 10 }} >
                <Stack direction={'row'} sx={{ width: '80%', mt: 3.5, ml: '155px', mr: 'auto' }}>
                    <Grid xs={4} item className="main_box" sx={{ height: '100% !important', p: 3 }}>
                        <Box sx={{ img }}><Typography className="svg_title">예약현황</Typography></Box>
                        <Stack sx={{ ml: 0, height: '100%' }} justifyContent={'space-between'} >

                            <List sx={{ width: '100%', p: '5px 0', bgcolor: '#fff', borderRadius: '20px', mt: 1 }}
                                onClick={() => util.strNull(window.localStorage.userCusID) === '' || reservationList.length < 1 ? navigate('../reservation') : {}}>
                                <ListItem alignItems="center" sx={{ p: 0, maxHeight: 230, overflow:'auto', alignItems:'flex-start' }} >

                                    <Stack sx={{ width: '100%', p: 0, }}>
                                        {
                                            util.strNull(window.localStorage.userCusID) === '' || allListCnt < 1
                                            ?   <Stack direction={'row'} justifyContent={'center'} onClick={() => navigate('/reservation')} sx={{mt:'70px'}}>
                                                    <EventBusyIcon sx={{ fontSize: 18, color: '#aaa', m: '3px 10px 0 0' }} />
                                                    <Typography sx={{ fontSize: 16, color: '#0d6703' }}>예약 정보가 없습니다</Typography>
                                                </Stack>
                                            : <>
                                                {
                                                    reservationList.length > 0
                                                    ? <Divider component="div" sx={{ height: 20, fontSize: 12, color: '#777', width: '90%', ml: 'auto', mr: 'auto' }}><Chip label="건강검진" sx={{height: 20, width: 80, fontSize: 12 }} /></Divider>
                                                    : null
                                                }

                                                {
                                                    reservationList.slice(0, 5).map((item, index) => (
                                                        <Stack className='reservationList' direction={'column'} justifyContent={'center'}
                                                            sx={{
                                                                p: 0,
                                                                bgcolor: '#f9f9f9',
                                                                borderRadius: 3,
                                                                mt: 1,
                                                                mb:1,
                                                                '&.reservationList:nth-child(n+1)': { py: 1, px: 2 },

                                                            }}
                                                            onClick={() => navigate('/reservation/SetFinishDetail', { state: { hoImage: item.hoImage, rsvId: item.rsvId, url: 'ReservationView' } })}>

                                                            <Stack direction={'row'} >
                                                                <PersonOutlineOutlinedIcon sx={{ fontSize: 18, color: '#aaa', m: '3px 10px 0 0', }} />
                                                                <Typography sx={{ fontSize: 16, color: '#777', mt: '0px', fontWeight: 700 }}>{item.famName}
                                                                    <Typography component={'span'} sx={{ fontSize: 14, color: '#555', mt: '2px', ml: .5 }}>{'(' + item.famGrade + ')'}</Typography>
                                                                </Typography>
                                                            </Stack>
                                                            <Stack direction={'row'} my={.5}>
                                                                <EventAvailableOutlinedIcon sx={{ fontSize: 18, color: '#aaa', m: '4px 10px 0 0' }} />
                                                                <Typography sx={{ fontSize: 16, fontWeight: 700, color: '#ff666c' }}>{util.strNull(item.ipDate) !== '' ? item.ipDate : item.firstWishDate} </Typography>
                                                                {item.reservationStatus.code <= 0 ? (
                                                                    <Chip label={item.reservationStatus.name} size="small" sx={{ ml: 2, verticalAlign: 'top', bgcolor: '#f18322', color: '#fff', }}></Chip>
                                                                ) : (
                                                                    <Chip label={item.reservationStatus.name} size="small" variant="outlined" sx={{ ml: 2, verticalAlign: 'top', bgcolor: '#fff', color: '#f18322', borderColor: '#f18322' }}></Chip>
                                                                )}
                                                            </Stack>

                                                            <Stack direction={'row'}>
                                                                <LocalHospitalOutlinedIcon sx={{ fontSize: 18, color: '#aaa', m: '4px 10px 0 0' }} />
                                                                <Typography sx={{ fontSize: 14, color: '#555', mt: '2px' }}> {item.hoName}</Typography>
                                                            </Stack>

                                                        </Stack>
                                                    ))
                                                }

                                                {
                                                    counselList.length > 0
                                                    ? <Divider component="div" sx={{mt: 1, height: 20, fontSize: 12, color: '#777', width: '90%', ml: 'auto', mr: 'auto' }}><Chip label="심리상담" sx={{height: 20, width: 80, fontSize: 12 }} /></Divider>
                                                    : null
                                                }

                                                {
                                                    counselList.slice(0, 5).map((item: any, index) => (
                                                        <Stack className='counselList' direction={'column'} justifyContent={'center'}
                                                            sx={{
                                                                p: 0,
                                                                bgcolor: '#f9f9f9',
                                                                borderRadius: 3,
                                                                mt: 1,
                                                                mb:1,
                                                                '&.counselList:nth-child(n+1)': { py: 1, px: 2 },

                                                            }}
                                                            onClick={() => navigate('/reservation/SetFinishDetail', { state: { hoImage: item.hoImage, rsvId: item.rsvId, url: 'ReservationView' } })}>

                                                            <Stack direction={'row'} >
                                                                <PersonOutlineOutlinedIcon sx={{ fontSize: 18, color: '#aaa', m: '3px 10px 0 0', }} />
                                                                <Typography sx={{ fontSize: 16, color: '#777', mt: '0px', fontWeight: 700 }}>{item.famName}
                                                                    <Typography component={'span'} sx={{ fontSize: 14, color: '#555', mt: '2px', ml: .5 }}>{'(' + item.famGrade + ')'}</Typography>
                                                                </Typography>
                                                            </Stack>
                                                            <Stack direction={'row'} my={.5}>
                                                                <EventAvailableOutlinedIcon sx={{ fontSize: 18, color: '#aaa', m: '4px 10px 0 0' }} />
                                                                <Typography sx={{ fontSize: 16, fontWeight: 700, color: '#ff666c' }}>
                                                                    {util.strNull(item.ipDate) !== '' ? item.ipDate : item.firstWishDate} {String(item.reservationTime).slice(0, -2)}:{String(item.reservationTime).slice(-2)}
                                                                </Typography>
                                                                {item.reservationStatus.code <= 0 ? (
                                                                    <Chip label={item.reservationStatus.name} size="small" sx={{ ml: 2, verticalAlign: 'top', bgcolor: '#f18322', color: '#fff', }}></Chip>
                                                                ) : (
                                                                    <Chip label={item.reservationStatus.name} size="small" variant="outlined" sx={{ ml: 2, verticalAlign: 'top', bgcolor: '#fff', color: '#f18322', borderColor: '#f18322' }}></Chip>
                                                                )}
                                                            </Stack>

                                                            <Stack direction={'row'}>
                                                                <LocalHospitalOutlinedIcon sx={{ fontSize: 18, color: '#aaa', m: '4px 10px 0 0' }} />
                                                                <Typography sx={{ fontSize: 14, color: '#555', mt: '2px' }}> {item.hoName}</Typography>
                                                            </Stack>

                                                        </Stack>
                                                    ))
                                                }
                                            </>
                                        }
                                    </Stack>

                                </ListItem>
                            </List>
                            <Stack direction={'row'} sx={{ textAlign: 'center', cursor: 'pointer', '& p': { width: '100%', p: '8px 0px', } }}>
                                <Typography sx={{ bgcolor: '#0d6703', color: '#fff', borderRadius: '10px 0 0 10px' }} onClick={() => navigate('/MyPage/MyPage')}>
                                    내정보 관리</Typography>
                                <Typography sx={{ bgcolor: '#5ead3d', color: '#fff', borderRadius: '0 10px 10px 0' }} onClick={() => logout()}>로그아웃</Typography>
                            </Stack>
                        </Stack>
                    </Grid>

                    <Stack direction={'column'} sx={{ width: '100%', ml: 5, display: 'grid' }}>
                        <Stack direction={'row'} sx={{ mb: 2 }}>
                            <Grid container className="justifycontent_spacebetween"
                                sx={{
                                    '& div': { position: 'relative' }, '& img': { position: 'absolute', right: 20, bottom: 15 },
                                    '& .main_box': { bgcolor: '#ffffffd9', cursor: 'pointer' }
                                }}>
                                <Grid item xs={localStorage.getItem('openConsultationReservation') == 'true' ? 2.8 : 3.8} className="main_box" onClick={() => navigate('/reservation')}>

                                    <AccessAlarmIcon className="svg_list" />
                                    <Typography className="svg_title">검진예약</Typography>
                                    <img src={arrowimg} alt="" style={{}} />
                                </Grid>
                                {
                                    localStorage.getItem('openConsultationReservation') == 'true'
                                    ? 
                                    <Grid item xs={2.8} className="main_box" onClick={() => navigate('/ConsultationReservation')}>
                                        <AccessAlarmIcon className="svg_list" />
                                        <Typography className="svg_title">심리상담예약</Typography>
                                        <img src={arrowimg} alt="" style={{}} />
                                    </Grid>
                                    : ''
                                }
                                <Grid xs={localStorage.getItem('openConsultationReservation') == 'true' ? 2.8 : 3.8} item className="main_box" onClick={() => navigate('/MyPage/HealthResult')} >

                                    <FactCheckOutlinedIcon className="svg_list" />
                                    <Typography className="svg_title">검진결과</Typography>
                                    <img src={arrowimg} alt="" style={{}} />
                                </Grid>
                                <Grid xs={localStorage.getItem('openConsultationReservation') == 'true' ? 2.8 : 3.8} item className="main_box" onClick={() => navigate('/comparisonHospital')} >
                                    <SupportAgentOutlinedIcon className="svg_list" />
                                    <Typography className="svg_title">병원별 비교</Typography>
                                    <img src={arrowimg} alt="" style={{}} />
                                </Grid>
                            </Grid>
                        </Stack>

                        <Grid container className="justifycontent_spacebetween" sx={{ cursor: 'pointer', '& div': { position: 'relative' }, '& img': { position: 'absolute', right: 20, bottom: 15 }, '& .main_box': { bgcolor: '#ffffffd9' } }}>
                            <Grid xs={3.8} item className="main_box" onClick={() => navigate('/Information')}>
                                <AccessAlarmIcon className="svg_list" />
                                <Typography className="svg_title">건강관리서비스</Typography>
                                <img src={arrowimg} alt="" style={{}} />
                            </Grid>
                            <Grid xs={3.8} item className="main_box" onClick={() => navigate('/encyclopedia')}>
                                <FactCheckOutlinedIcon className="svg_list" />
                                <Typography className="svg_title">건강콘텐츠</Typography>
                                <img src={arrowimg} alt="" style={{}} />
                            </Grid>
                            <Grid xs={3.8} item className="main_box" onClick={() => navigate('/check/Counsel')}>
                                <SupportAgentOutlinedIcon className="svg_list" />
                                <Typography className="svg_title">고객센터</Typography>
                                <Box>
                                    <Typography className="svg_text">전화 : 1661-2645</Typography>
                                    {/* <Typography className="svg_text">이메일 : dualhealth@gmail.com</Typography> */}
                                </Box>
                                <img src={arrowimg} alt="" style={{}} />
                            </Grid>
                        </Grid>
                    </Stack>

                </Stack>
            </Grid>

            {/* <List sx={{ width: '100%', p: '5px 0', bgcolor: '#fff', borderRadius: '20px', m: '15px 0' }} onClick={() => navigate('../reservation')}>
        <ListItem alignItems="center" >
          <ListItemAvatar sx={{ bgcolor: '#FEF8F5', width: 64, height: 64, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Avatar alt="" src={write} sx={{ borderRadius: 0 }} />
          </ListItemAvatar>
          <Stack sx={{ ml: 2 }}>
            <Typography sx={{ fontSize: 14, color: '#666' }}>건강검진 기록 한번에 보기</Typography>
            <Typography sx={{ fontSize: 18, fontWeight: 700, m: '5px 0', color: '#555' }}>건강검진 기록</Typography>
            <Stack direction={'row'}>
              <RestoreOutlinedIcon sx={{ fontSize: 18, color: '#aaa', m: '2px 10px 0 0' }} />
              <Typography sx={{ fontSize: 14, color: '#EF8322' }}>건강검진 기록이 없습니다</Typography>
            </Stack>
          </Stack>
        </ListItem>
      </List> */}

            {/*
      <List sx={{ width: '100%', p:'5px 0', bgcolor: '#fff', borderRadius:'20px', }} onClick={() => navigate('../reservation')}>
        <ListItem alignItems="center" >
          <ListItemAvatar sx={{bgcolor:'#FEF8F5', width:64, height:64, borderRadius:'50%', display:'flex',alignItems:'center',justifyContent:'center'}}>
            <Avatar alt="" src={center} sx={{borderRadius:0}} />
          </ListItemAvatar>
          <Stack sx={{ ml: 2 }}>
            <Typography sx={{ fontSize: 14, color:'#666'}}>가까운 건강검진센터 찾아보기</Typography>
            <Typography sx={{ fontSize: 18, fontWeight: 700, m:'5px 0', color:'#555' }}>건강검진센터 찾기</Typography>
            <Stack direction={'row'}>
              <AddLocationOutlinedIcon sx={{fontSize:18, color:'#aaa', m:'2px 10px 0 0'}} />
              <Typography sx={{ fontSize: 14, color:'#555' }}>대전광역시 유성구</Typography>
            </Stack>
          </Stack>
        </ListItem>
      </List>
  */}
        </React.Fragment>

    );
}


const img = {
    display: 'flex', p: 0, backgroundImage: `url(${tab04})`, backgroundSize: 'cover', mb: 5, borderRadius: 2
}


export default MainMedical;